module.exports = __webpack_public_path__ + "static/media/proyeccion_participacion.0184123d.png";